import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AccountService } from '@banyan/features/account/services/account.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { catchError, from, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private readonly platformId = inject(PLATFORM_ID);


  accountService = inject(AccountService);
  oAuthService = inject(OAuthService);
  router = inject(Router);


  canActivateChild(
    _: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {

    const { url } = state;
    const isAuthenticated = this.oAuthService.hasValidAccessToken();

    if (isAuthenticated) {
      return of(isAuthenticated);
    }

    const hasRefreshToken = this.oAuthService.getRefreshToken() || null;

    if (hasRefreshToken) {
      return from(this.oAuthService.refreshToken()).pipe(
        switchMap(() => {
          const isAuthenticated = this.oAuthService.hasValidAccessToken();

          if (!isAuthenticated) {
            this.accountService.initAuth(url);
          }

          return of(isAuthenticated);
        }),
        catchError(() => {
          this.accountService.initAuth(url);
          return of(false);
        }));
    }

    if (url.startsWith('/protected')) {
      if (isPlatformBrowser(this.platformId)) {
        window.localStorage.setItem('Url', url);
      }
      if (url.startsWith('/protected/capture-needs')) {
        return of(this.router.createUrlTree(['register']));
      }
    }


    this.accountService.initAuth(url);
    return of(false);
  }
}
